import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import estilos from '../../Tabs/TabsInspeccionarComponent.module.css'
import EditIcon from '@mui/icons-material/Edit';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

import { useContext } from 'react';
import InspectorEnCampoContext from '../../../Context/InspectorEnCampoContext';
import { getanexoByIdInforme } from '../../../../../redux/DucksUnidadInspeccion/Fi25anexoDuck';
import { insertFotoGaleria } from '../../../../../redux/DucksUnidadInspeccion/FotogaleriaDuck';
import { ReactNotifications } from 'react-notifications-component'
import { Store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css'
import SeccionFotogaleriaComponent from './SeccionFotogaleriaComponent';

function FotoFaleriaComponent(props) {

    const dispatch = useDispatch();

    const { fotoGaleriaContext, setContextFotoGaleria } = useContext(InspectorEnCampoContext);

    const [isContext, setIsContext] = React.useState(false);

    //AREAS DIVERSAS
    const [fotosLaboratorio, setFotosLaboratorio] = React.useState([]);
    const [fotosSanitarios, setFotosSanitarios] = React.useState([]);
    const [fotosEstacionamiento, setFotosEstacionamiento] = React.useState([]);
    const [fotosOficinas, setFotosOficinas] = React.useState([]);
    const [fotosCarga, setFotosCarga] = React.useState([]);
    const [fotosOtros, setFotosOtros] = React.useState([]);

    //AREAS
    const [fotosPesado, setFotosPesado] = React.useState([]);
    const [fotosCoccion, setFotosCoccion] = React.useState([]);
    const [fotosMolienda, setFotosMolienda] = React.useState([]);
    const [fotosFermentacion, setFotosFermentacion] = React.useState([]);
    const [fotosDestilacion, setFotosDestilacion] = React.useState([]);

    //GENERALES
    const [fotosProductor, setFotosProductor] = React.useState([]);
    const [fotosVistaGeneral, setfotosVistaGeneral] = React.useState([]);
    const [fotosMateriaPrima, setfotosMateriaPrima] = React.useState([]);
    const [fotosRecepcionMateriaPrima, setfotosRecepcionMateriaPrima] = React.useState([]);
    const [fotosAlmacenGranel, setfotosAlmacenGranel] = React.useState([]);

    const todo = props.todo;
    const idinforme = props.idinforme;
    const idanexo = useSelector(store => store.anexo.anexo);
    const instalacion = props.instalacion - 1;

    React.useEffect(() => {
        if (idinforme?.idfi_25_informecumplimientonom) {
            dispatch(getanexoByIdInforme(idinforme.idfi_25_informecumplimientonom)) //informe
        }
        if (fotoGaleriaContext != null) {
            setFotosLaboratorio(fotoGaleriaContext.fotosLaboratorio)
            setFotosSanitarios(fotoGaleriaContext.fotosSanitarios)
            setFotosEstacionamiento(fotoGaleriaContext.fotosEstacionamiento)
            setFotosOficinas(fotoGaleriaContext.fotosOficinas)
            setFotosCarga(fotoGaleriaContext.fotosCarga)
            setFotosOtros(fotoGaleriaContext.fotosOtros)
            setFotosPesado(fotoGaleriaContext.fotosPesado)
            setFotosCoccion(fotoGaleriaContext.fotosCoccion)
            setFotosMolienda(fotoGaleriaContext.fotosMolienda)
            setFotosFermentacion(fotoGaleriaContext.fotosFermentacion)
            setFotosDestilacion(fotoGaleriaContext.fotosDestilacion)
            setFotosProductor(fotoGaleriaContext.fotosProductor)
            setfotosVistaGeneral(fotoGaleriaContext.fotosVistaGeneral)
            setfotosMateriaPrima(fotoGaleriaContext.fotosMateriaPrima)
            setfotosRecepcionMateriaPrima(fotoGaleriaContext.fotosRecepcionMateriaPrima)
            setfotosAlmacenGranel(fotoGaleriaContext.fotosAlmacenGranel)
            setIsContext(true)
        }
    }, [])

    React.useEffect(() => {
        const data = {
            fotosLaboratorio: fotosLaboratorio,
            fotosSanitarios: fotosSanitarios,
            fotosEstacionamiento: fotosEstacionamiento,
            fotosOficinas: fotosOficinas,
            fotosCarga: fotosCarga,
            fotosOtros: fotosOtros,
            fotosPesado: fotosPesado,
            fotosCoccion: fotosCoccion,
            fotosMolienda: fotosMolienda,
            fotosFermentacion: fotosFermentacion,
            fotosDestilacion: fotosDestilacion,
            fotosProductor: fotosProductor,
            fotosVistaGeneral: fotosVistaGeneral,
            fotosMateriaPrima: fotosMateriaPrima,
            fotosRecepcionMateriaPrima: fotosRecepcionMateriaPrima,
            fotosAlmacenGranel: fotosAlmacenGranel,
            submit: true
        }

        setContextFotoGaleria(data)
    }, [fotosLaboratorio, fotosSanitarios, fotosEstacionamiento, fotosOficinas, fotosCarga, fotosOtros, fotosProductor, fotosPesado, fotosCoccion, fotosMolienda, fotosFermentacion, fotosDestilacion, , fotosVistaGeneral, fotosMateriaPrima, fotosRecepcionMateriaPrima, fotosAlmacenGranel]);


    const handleLaboratorio = (event) => {
        if (event.target.files[0] != undefined) {
            setFotosLaboratorio([...fotosLaboratorio, event.target.files[0]]);
        }
    }
    const handleSanitarios = (event) => {
        if (event.target.files[0] != undefined) {
            setFotosSanitarios([...fotosSanitarios, event.target.files[0]]);
        }
    }
    const handleEstacionamiento = (event) => {
        if (event.target.files[0] != undefined) {
            setFotosEstacionamiento([...fotosEstacionamiento, event.target.files[0]]);
        }
    }
    const handleOficinas = (event) => {
        if (event.target.files[0] != undefined) {
            setFotosOficinas([...fotosOficinas, event.target.files[0]]);
        }
    }
    const handleCarga = (event) => {
        if (event.target.files[0] != undefined) {
            setFotosCarga([...fotosCarga, event.target.files[0]]);
        }
    }
    const handleOtros = (event) => {
        if (event.target.files[0] != undefined) {
            setFotosOtros([...fotosOtros, event.target.files[0]]);
        }
    }
    const handleProductor = (event) => {
        if (event.target.files[0] != undefined) {
            setFotosProductor([...fotosProductor, event.target.files[0]]);
        }
    }

    const handlePesado = (event) => {
        if (event.target.files[0] != undefined) {
            setFotosPesado([...fotosPesado, event.target.files[0]]);
        }
    }

    const handleCoccion = (event) => {
        if (event.target.files[0] != undefined) {
            setFotosCoccion([...fotosCoccion, event.target.files[0]]);
        }
    }

    const handleMolienda = (event) => {
        if (event.target.files[0] != undefined) {
            setFotosMolienda([...fotosMolienda, event.target.files[0]]);
        }
    }

    const handleFermentacion = (event) => {
        if (event.target.files[0] != undefined) {
            setFotosFermentacion([...fotosFermentacion, event.target.files[0]]);
        }
    }

    const handleDestilacion = (event) => {
        if (event.target.files[0] != undefined) {
            setFotosDestilacion([...fotosDestilacion, event.target.files[0]]);
        }
    }

    const handleVistaGeneral = (event) => {
        if (event.target.files[0] != undefined) {
            setfotosVistaGeneral([...fotosVistaGeneral, event.target.files[0]]);
        }
    }

    const handleMateriaPrima = (event) => {
        if (event.target.files[0] != undefined) {
            setfotosMateriaPrima([...fotosMateriaPrima, event.target.files[0]]);
        }
    }

    const handleRecepcionMateriaPrima = (event) => {
        if (event.target.files[0] != undefined) {
            setfotosRecepcionMateriaPrima([...fotosRecepcionMateriaPrima, event.target.files[0]]);
        }
    }

    const handleAlmacenGranel = (event) => {
        if (event.target.files[0] != undefined) {
            setfotosAlmacenGranel([...fotosAlmacenGranel, event.target.files[0]]);
        }
    }



    const agregarFotogaleria = () => {

        try {

            if (fotosCoccion.length > 0) {
                fotosCoccion.map((f, index) => {

                    const data = {
                        data: {
                            idfi_25anexo: parseInt(idanexo.idfi_25anexo),
                            idseccion: 1,
                            ruta: ""
                        },
                        imagen: f
                    }
                    dispatch(insertFotoGaleria(data))

                })
            }

            if (fotosMolienda.length > 0) {
                fotosMolienda.map((f, index) => {

                    const data = {
                        data: {
                            idfi_25anexo: parseInt(idanexo.idfi_25anexo),
                            idseccion: 2,
                            ruta: ""
                        },
                        imagen: f
                    }
                    dispatch(insertFotoGaleria(data))
                })
            }

            if (fotosFermentacion.length > 0) {
                fotosFermentacion.map((f, index) => {

                    const data = {
                        data: {
                            idfi_25anexo: parseInt(idanexo.idfi_25anexo),
                            idseccion: 3,
                            ruta: ""
                        },
                        imagen: f
                    }
                    dispatch(insertFotoGaleria(data))
                })
            }

            if (fotosDestilacion.length > 0) {
                fotosDestilacion.map((f, index) => {

                    const data = {
                        data: {
                            idfi_25anexo: parseInt(idanexo.idfi_25anexo),
                            idseccion: 4,
                            ruta: ""
                        },
                        imagen: f
                    }
                    dispatch(insertFotoGaleria(data))
                })
            }

            if (fotosLaboratorio.length > 0) {
                fotosLaboratorio.map((f, index) => {

                    const data = {
                        data: {
                            idfi_25anexo: parseInt(idanexo.idfi_25anexo),
                            idseccion: 20,
                            ruta: ""
                        },
                        imagen: f
                    }
                    dispatch(insertFotoGaleria(data))
                })
            }

            if (fotosOficinas.length > 0) {
                fotosOficinas.map((f, index) => {

                    const data = {
                        data: {
                            idfi_25anexo: parseInt(idanexo.idfi_25anexo),
                            idseccion: 23,
                            ruta: ""
                        },
                        imagen: f
                    }
                    dispatch(insertFotoGaleria(data))
                })
            }

            if (fotosCarga.length > 0) {
                fotosCarga.map((f, index) => {

                    const data = {
                        data: {
                            idfi_25anexo: parseInt(idanexo.idfi_25anexo),
                            idseccion: 24,
                            ruta: ""
                        },
                        imagen: f
                    }
                    dispatch(insertFotoGaleria(data))
                })
            }

            if (fotosOtros.length > 0) {
                fotosOtros.map((f, index) => {

                    const data = {
                        data: {
                            idfi_25anexo: parseInt(idanexo.idfi_25anexo),
                            idseccion: 25,
                            ruta: ""
                        },
                        imagen: f
                    }
                    dispatch(insertFotoGaleria(data))
                })
            }

            if (fotosProductor.length > 0) {
                fotosProductor.map((f, index) => {

                    const data = {
                        data: {
                            idfi_25anexo: parseInt(idanexo.idfi_25anexo),
                            idseccion: 15,
                            ruta: ""
                        },
                        imagen: f
                    }
                    dispatch(insertFotoGaleria(data))
                })
            }

            if (fotosVistaGeneral.length > 0) {
                fotosVistaGeneral.map((f, index) => {

                    const data = {
                        data: {
                            idfi_25anexo: parseInt(idanexo.idfi_25anexo),
                            idseccion: 16,
                            ruta: ""
                        },
                        imagen: f
                    }
                    dispatch(insertFotoGaleria(data))
                })
            }

            if (fotosMateriaPrima.length > 0) {
                fotosMateriaPrima.map((f, index) => {

                    const data = {
                        data: {
                            idfi_25anexo: parseInt(idanexo.idfi_25anexo),
                            idseccion: 17,
                            ruta: ""
                        },
                        imagen: f
                    }
                    dispatch(insertFotoGaleria(data))
                })
            }

            if (fotosRecepcionMateriaPrima.length > 0) {
                fotosRecepcionMateriaPrima.map((f, index) => {

                    const data = {
                        data: {
                            idfi_25anexo: parseInt(idanexo.idfi_25anexo),
                            idseccion: 18,
                            ruta: ""
                        },
                        imagen: f
                    }
                    dispatch(insertFotoGaleria(data))
                })
            }

            if (fotosAlmacenGranel.length > 0) {
                fotosAlmacenGranel.map((f, index) => {

                    const data = {
                        data: {
                            idfi_25anexo: parseInt(idanexo.idfi_25anexo),
                            idseccion: 19,
                            ruta: ""
                        },
                        imagen: f
                    }
                    dispatch(insertFotoGaleria(data))
                })
            }

            const data = {
                fotosLaboratorio: fotosLaboratorio,
                fotosSanitarios: fotosSanitarios,
                fotosEstacionamiento: fotosEstacionamiento,
                fotosOficinas: fotosOficinas,
                fotosCarga: fotosCarga,
                fotosOtros: fotosOtros,
                fotosPesado: fotosPesado,
                fotosCoccion: fotosCoccion,
                fotosMolienda: fotosMolienda,
                fotosFermentacion: fotosFermentacion,
                fotosDestilacion: fotosDestilacion,
                fotosProductor: fotosProductor,
                fotosVistaGeneral: fotosVistaGeneral,
                fotosMateriaPrima: fotosMateriaPrima,
                fotosRecepcionMateriaPrima: fotosRecepcionMateriaPrima,
                fotosAlmacenGranel: fotosAlmacenGranel,
                submit: true
            }

            setContextFotoGaleria(data)


            Store.addNotification({
                title: "Fotogalería",
                message: "Guardada Correctamente",
                type: "success",
                insert: "top",
                container: "top-center",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 3000,
                    onScreen: true
                }
            });
        } catch (error) {
            console.log(error)
        }

    }

    return (
        <Fragment>
            <Formik
                initialValues={{}}
                validate={(valores) => {

                    const data = {
                        fotosLaboratorio: fotosLaboratorio,
                        fotosSanitarios: fotosSanitarios,
                        fotosEstacionamiento: fotosEstacionamiento,
                        fotosOficinas: fotosOficinas,
                        fotosCarga: fotosCarga,
                        fotosOtros: fotosOtros,
                        fotosPesado: fotosPesado,
                        fotosCoccion: fotosCoccion,
                        fotosMolienda: fotosMolienda,
                        fotosFermentacion: fotosFermentacion,
                        fotosDestilacion: fotosDestilacion,
                        fotosProductor: fotosProductor,
                        fotosVistaGeneral: fotosVistaGeneral,
                        fotosMateriaPrima: fotosMateriaPrima,
                        fotosRecepcionMateriaPrima: fotosRecepcionMateriaPrima,
                        fotosAlmacenGranel: fotosAlmacenGranel,
                        submit: false
                    }

                    setContextFotoGaleria(data)
                }}
                onSubmit={(valores) => {
                    //console.log(valores)
                }}
            >
                {(props) => (
                    <div className='mt-5'>
                        <hr></hr>
                        <div className='row mb-3'>
                            <label className={`${estilos.labelUI} mb-2`}>GENERALES</label>
                            <SeccionFotogaleriaComponent nombreSeccion={'Productor de Mezcal'} valores={fotosProductor} metodo={handleProductor} />
                            <SeccionFotogaleriaComponent nombreSeccion={'Vista general de las instalaciones'} valores={fotosVistaGeneral} metodo={handleVistaGeneral} />
                            <SeccionFotogaleriaComponent nombreSeccion={'Materia Prima'} valores={fotosMateriaPrima} metodo={handleMateriaPrima} />
                            <SeccionFotogaleriaComponent nombreSeccion={'Recepción de Materia Prima'} valores={fotosRecepcionMateriaPrima} metodo={handleRecepcionMateriaPrima} />
                            <SeccionFotogaleriaComponent nombreSeccion={'Almacén de producto a granel'} valores={fotosAlmacenGranel} metodo={handleAlmacenGranel} />
                            <hr></hr><br /><br />
                            <label className={`${estilos.labelUI} mb-2`}>ÁREAS</label>
                            <SeccionFotogaleriaComponent nombreSeccion={'Área de Pesado de Maguey'} valores={fotosPesado} metodo={handlePesado} />
                            <SeccionFotogaleriaComponent nombreSeccion={'Área de Cocción'} valores={fotosCoccion} metodo={handleCoccion} />
                            <SeccionFotogaleriaComponent nombreSeccion={'Área de Molienda'} valores={fotosMolienda} metodo={handleMolienda} />
                            <SeccionFotogaleriaComponent nombreSeccion={'Área de Fermentación'} valores={fotosFermentacion} metodo={handleFermentacion} />
                            <SeccionFotogaleriaComponent nombreSeccion={'Área de Destilación'} valores={fotosDestilacion} metodo={handleDestilacion} />

                            <hr></hr><br /><br />
                            <label className={`${estilos.labelUI} mb-2`}>ÁREAS DIVERSAS</label>
                            <SeccionFotogaleriaComponent nombreSeccion={'Laboratorio'} valores={fotosLaboratorio} metodo={handleLaboratorio} />
                            <SeccionFotogaleriaComponent nombreSeccion={'Sanitarios'} valores={fotosSanitarios} metodo={handleSanitarios} />
                            <SeccionFotogaleriaComponent nombreSeccion={'Estacionamiento'} valores={fotosEstacionamiento} metodo={handleEstacionamiento} />
                            <SeccionFotogaleriaComponent nombreSeccion={'Oficinas'} valores={fotosOficinas} metodo={handleOficinas} />
                            <SeccionFotogaleriaComponent nombreSeccion={'Equipo de carga (patines, montacargas)'} valores={fotosCarga} metodo={handleCarga} />
                            <SeccionFotogaleriaComponent nombreSeccion={'Otros'} valores={fotosOtros} metodo={handleOtros} />
                            <hr></hr><br /><br />

                        </div>

                        {
                            //<div className="row mb-5">
                            //    <div className="col ">
                            //        <button className={`btn ${estilos.botonVerdeCOMERCAM}`} type='submit' onClick={agregarFotogaleria}>GUARDAR</button>
                            //    </div>
                            //
                            //</div>
                        }
                    </div>
                )}
            </Formik>
        </Fragment>
    );
};


export default withRouter(FotoFaleriaComponent)
